// Timezone helpers — everything in the Web Changes log is Australia/Sydney,
// pinned explicitly so it reads correctly regardless of the viewer's machine.
// Storage is an absolute instant (ISO string); display + input are Sydney.

const TZ = 'Australia/Sydney';

// Minutes Sydney is ahead of UTC at a given instant (handles AEST/AEDT).
function sydneyOffsetMinutes(date) {
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ, hour12: false,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
  const p = dtf.formatToParts(date).reduce((a, x) => { a[x.type] = x.value; return a; }, {});
  const asUTC = Date.UTC(p.year, p.month - 1, p.day, p.hour === '24' ? 0 : p.hour, p.minute, p.second);
  return (asUTC - date.getTime()) / 60000;
}

// Combine a Sydney wall-clock date ('YYYY-MM-DD') + time ('HH:MM') into the
// correct absolute instant (ISO string).
export function sydneyToInstant(dateStr, timeStr) {
  if (!dateStr) return null;
  const [y, m, d] = dateStr.split('-').map(Number);
  const [hh, mm] = (timeStr || '00:00').split(':').map(Number);
  const naiveUTC = Date.UTC(y, (m || 1) - 1, d || 1, hh || 0, mm || 0);
  const offset = sydneyOffsetMinutes(new Date(naiveUTC));
  return new Date(naiveUTC - offset * 60000).toISOString();
}

// Split an instant back into Sydney date + time input values (for editing).
export function instantToSydneyParts(ts) {
  const d = ts ? new Date(ts) : new Date();
  const dtf = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ, hour12: false,
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
  });
  const p = dtf.formatToParts(d).reduce((a, x) => { a[x.type] = x.value; return a; }, {});
  const hour = p.hour === '24' ? '00' : p.hour;
  return { date: `${p.year}-${p.month}-${p.day}`, time: `${hour}:${p.minute}` };
}

export function nowSydneyParts() {
  return instantToSydneyParts(new Date().toISOString());
}

// "18 Jul 2026"
export function formatDate(ts) {
  if (!ts) return '';
  return new Date(ts).toLocaleDateString('en-AU', { timeZone: TZ, day: 'numeric', month: 'short', year: 'numeric' });
}

// "12:30 am"
export function formatTime(ts) {
  if (!ts) return '';
  return new Date(ts).toLocaleTimeString('en-AU', { timeZone: TZ, hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase();
}

// "18 Jul 2026, 12:30 am" — for the activity feed / created-by lines.
export function formatWhen(ts) {
  if (!ts) return '';
  return new Date(ts).toLocaleString('en-AU', {
    timeZone: TZ, day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true,
  }).toLowerCase();
}
